module.exports = __webpack_public_path__ + "img/sample_06_big.660f561b.gif";